export const fontFamily = {
  nort: "'nort', sans-serif, Helvetica, Arial, Verdana, Tahoma",
  robotoMono: "'Roboto Mono', monospace, Helvetica, Arial, Verdana, Tahoma",
};

export const Fonts = {
  '--font-nort': fontFamily.nort,
  '--font-roboto-mono': fontFamily.robotoMono,
};
